import { supabaseClient } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { UserPreferredUnit } from '@core';
import { getAllCorridors, getAllCorridorsV2 } from '@data';

export const getCorridorsQueryKey = (userPreferredUnit: UserPreferredUnit) => ['corridors', userPreferredUnit];
export const getCorridorsV2QueryKey = () => ['corridors', 'v2'];

export const useCorridors = (userPreferredUnit: UserPreferredUnit) => {
    return useQuery({
        queryKey: getCorridorsQueryKey(userPreferredUnit),
        queryFn: () => getAllCorridors(supabaseClient, userPreferredUnit),
        retry: 3,
    });
};

export const useCorridorsV2 = () => {
    return useQuery({
        queryKey: getCorridorsV2QueryKey(),
        queryFn: () => getAllCorridorsV2(supabaseClient),
        retry: 3,
    });
};
